/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Scanned(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 3C2.25 2.58579 2.58579 2.25 3 2.25H6H6.75V3.75H6H3.75V6V6.75H2.25V6V3ZM17.25 2.25H18H21C21.4142 2.25 21.75 2.58579 21.75 3V6V6.75H20.25V6V3.75H18H17.25V2.25ZM3.75 17.25V18V20.25H6H6.75V21.75H6H3C2.58579 21.75 2.25 21.4142 2.25 21V18V17.25H3.75ZM21.75 17.25V18V21C21.75 21.4142 21.4142 21.75 21 21.75H18H17.25V20.25H18H20.25V18V17.25H21.75ZM1.25 12.25H2H22H22.75V13.75H22H2H1.25V12.25ZM8 9C7.44772 9 7 9.44771 7 10C7 10.5523 7.44772 11 8 11C8.55228 11 9 10.5523 9 10C9 9.44771 8.55228 9 8 9ZM11 7C11 6.44771 11.4477 6 12 6C12.5523 6 13 6.44771 13 7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7ZM12 9C11.4477 9 11 9.44771 11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10C13 9.44771 12.5523 9 12 9ZM15 7C15 6.44771 15.4477 6 16 6C16.5523 6 17 6.44771 17 7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7ZM16 9C15.4477 9 15 9.44771 15 10C15 10.5523 15.4477 11 16 11C16.5523 11 17 10.5523 17 10C17 9.44771 16.5523 9 16 9Z"
        fill="currentColor"
      />
    </svg>
  )
}

Scanned.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Scanned
